<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  <p class="f-family-bold f-size-xs mt-3 mb-2">{{ t('passwordFormatHeader') }}:</p>
  <ul class="f-size-xs">
    <li>{{ t('passwordFormatBody_1') }}</li>
    <li>{{ t('passwordFormatBody_2') }}</li>
    <li>{{ t('passwordFormatBody_3') }}</li>
    <li>{{ t('passwordFormatBody_4') }}</li>
  </ul>
</ng-container>
